import { Link, useLocation } from 'react-router-dom';
import { useCartContext } from '../api/cart-provider.js';
import { formatClock } from '../api/use-cart.js';
import { useCountdown } from './use-countdown.js';

/**
 * The hold, followed off the booking screens.
 *
 * Ruled 13 October by Matthew: "Need some indicator outside of book page that
 * there is a timer for the cart, doesn't need to be the full button but the
 * counter somewhere with a link to the cart." This overturns 22 September's
 * "the clock rides the primary button and lives nowhere else" for every screen
 * that has no such button.
 *
 * A SLIM STRIP ABOVE THE TABS, chosen over a header pill (the header is full at
 * 390px) and over the Book tab (a tab that changes destination while a cart is
 * live is a tab nobody can predict). It is where the thumb already is.
 *
 * NOT ON BOOK, AN HOUR OR THE CART. Those carry the clock on their primary
 * button, and two clocks on one screen is one too many.
 *
 * The lapse itself is noticed by CartProvider, not here: at zero the cart is
 * re-read, it comes back empty, and the strip goes with it.
 */
export function CartStrip() {
  const { pathname } = useLocation();
  const { state } = useCartContext();
  const cart = state.status === 'ready' ? state.cart : null;
  const left = useCountdown(cart && cart.lines.length > 0 ? cart.expires_at : null);

  const onBookingScreen = pathname.startsWith('/booking') || pathname.startsWith('/cart');
  if (onBookingScreen || !cart || cart.lines.length === 0 || left === null || left === 0) {
    return null;
  }

  return (
    <Link className="cart-strip" to="/cart">
      <span>{cart.lines.length} in your cart</span>
      <span className="clock">{formatClock(left)}</span>
      <span className="chevron" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
